function lasers() {
  var af;

  var numLasers = 250;
  if (window.innerWidth < 800) {
    numLasers = 100;
  }

  var tail = 200;
  var canvas = document.querySelector("#lasers");
  var ctx = canvas.getContext("2d");

  function createLasers(n) {
    var lasers = [];

    for (var i = 0; i < n; ++i) {
      lasers.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        s: Math.random() * 2 + 1
      });
    }

    return lasers;
  }

  function renderLaser(l) {
    var grad = ctx.createLinearGradient(l.x, l.y, l.x, l.y + tail);
    var a = 1 - (canvas.height - l.y) / canvas.height * 0.8;
    grad.addColorStop(0, "hsla(177,100%,31%," + a + ")");
    grad.addColorStop(1, "hsla(177,100%,31%,0)");
    ctx.strokeStyle = grad;
    ctx.beginPath();
    ctx.moveTo(l.x, l.y);
    ctx.lineTo(l.x, l.y + tail);
    ctx.stroke();
  }

  function updateLaser(l) {
    l.y -= l.s;
    if (l.y < -tail) {
      l.y = canvas.height;
    }
  }

  function render(lasers) {
    ctx.fillStyle = "hsl(234,28%,7%)";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    for (var i = 0; i < lasers.length; i++) {
      var l = lasers[i];
      renderLaser(l);
      updateLaser(l);
    }

    af = requestAnimationFrame(function() {
      render(lasers);
    });
  }

  function init() {
    cancelAnimationFrame(af);
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    af = requestAnimationFrame(function() {
      var lazers = createLasers(numLasers);
      render(lazers);
    });
  }

  window.onresize = init;
  init();
};

if( document.readyState !== 'loading' ) {
  lasers();
} else {
  document.addEventListener('DOMContentLoaded', function () {
    lasers();
  });
}
